import React from 'react'

export default function Brand() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
      {/* Official logo from www.pandonia-global-network.org/assets/images/cropped-pgn_logo_7_final_transbg-2.png */}
      <img src={`${process.env.PUBLIC_URL}/pgn-logo.png`} alt="Pandonia Global Network" width="44" height="44" style={{ flexShrink: 0 }} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 22, fontWeight: 650, letterSpacing: '-0.035em', lineHeight: 1.2 }}>BlickM</div>
        <div style={{ fontSize: 11, color: 'var(--text-secondary, #617187)', letterSpacing: '0.035em', lineHeight: 1.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Pandonia Global Network</div>
      </div>
    </div>
  )
}
